import type { ColDef, ValueFormatterParams, ValueGetterParams } from 'ag-grid-community';

import type { TypeDeliveryAgencyOutboundUnit } from '~/types/delivery-agency.types';

const getDeliveryAgencyOutboundUnitColumnDefs = () => {
  const calculateTableHeight = (shippingLabelNumbers?: string[]) => {
    const LINE_HEIGHT = 20;
    const PADDING = 22;
    const HEADER_HEIGHT = 44;
    const EMPTY_OVERLAY_HEIGHT = 120;
    const contentHeight = shippingLabelNumbers?.length
      ? shippingLabelNumbers.length * LINE_HEIGHT + PADDING
      : EMPTY_OVERLAY_HEIGHT;
    return contentHeight + HEADER_HEIGHT;
  };

  const columnDefs: ColDef<TypeDeliveryAgencyOutboundUnit>[] = [
    {
      field: 'outboundCode',
      headerName: '출고번호',
      width: 160,
    },
    {
      field: 'isCreatableShippingLabel',
      headerName: '추가 운송장 생성 가능 여부',
      width: 200,
      valueGetter: ({
        data,
      }: ValueGetterParams<
        TypeDeliveryAgencyOutboundUnit,
        TypeDeliveryAgencyOutboundUnit['isCreatableShippingLabel']
      >) => {
        if (!data) return '-';
        return data.isCreatableShippingLabel ? '생성 가능' : '생성 불가능';
      },
    },
    {
      field: 'shippingLabelNumbers',
      headerName: '운송장 번호',
      width: 245,
      wrapText: true,
      autoHeight: true,
      cellStyle: { whiteSpace: 'pre', lineHeight: '20px', padding: '9px 0' },
      valueFormatter: ({
        value,
      }: ValueFormatterParams<
        TypeDeliveryAgencyOutboundUnit,
        TypeDeliveryAgencyOutboundUnit['shippingLabelNumbers']
      >) => value?.join('\n') ?? '-',
    },
    {
      field: 'receiverName',
      headerName: '수령자명',
      width: 100,
    },
    {
      field: 'productName',
      headerName: '상품명',
      flex: 1,
      minWidth: 252,
      width: 252,
    },
  ];

  return { calculateTableHeight, columnDefs };
};

export default getDeliveryAgencyOutboundUnitColumnDefs;
